// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"e17051ad","317":"2eb18170","357":"2eb18170","429":"8d14e5bc","581":"f2ed4042","779":"f2ed4042"}[chunkId] + ".chunk.css";
};